module.exports = __webpack_public_path__ + "img/sad_delete.d14cd80e.svg";